import Form from 'react-bootstrap/Form';
import React, { useState, useEffect } from "react"
import {useNavigate} from 'react-router-dom';
import TitleDiv from '../../../components/shared/TitleDiv.js';
import FailIconDiv from '../../../components/fail/FailIconDiv.js';
import SuccessMsgDiv from '../../../components/fail/SuccessMsgDiv.js';
import EnquiryDiv from '../../../components/fail/EnquiryDiv.js';
import ReceivedSmsDiv from '../../../components/fail/ReceivedSmsDiv.js';
import DateConverter from '../../../components/converter/DateConverter.js';
import '../../../css/PaymentResult.css';

function NPSuccess(props) {

    console.log(props.invoiceno);
    console.log(props.hash);
    const navigate = useNavigate();
    const PUBLIC_URL = process.env.PUBLIC_URL;
    const url = new URL(window.location.href);
    let baseUrl = `${url.protocol}//${url.host}/`;


    
    if (process.env.REACT_APP_API_URL != ""){
      baseUrl = process.env.REACT_APP_API_URL;
    }
    const paymentUrl = baseUrl + "frontend/api/NPEnroll/GetNonPaymentResult";
    const iconUrl = baseUrl + "frontend/api/Enroll/GetImageURLbyStatus";
    const eventUrl = baseUrl + "frontend/api/Enroll/GetEventStatus";
    const eventName = window.name;

    let noticeMsg = "你已成功登記";
    if (eventName == "20250622_945Promotion")
    {
       noticeMsg = "你已成功登記【生日驚喜夜鳥945】電子優惠券";
    }
    else if (eventName =="2025_tasting_certificate" || eventName =="2025_tasting_certificate2")
    {
       noticeMsg = "你已成功登記【試食証】";
    }
    else if (eventName =="2025062122_carnival")
    {
        noticeMsg = "你已成功登記【樓上二十七周年誌慶嘉年華】入場電子門券";
    }
    else if (eventName =="20251230_pistachio_gift")
    {
        noticeMsg = "你已成功登記【領取馬年開心果 (45克X2包)】";
    }
    if (eventName =="2026032829_TSTopening")
    {
        noticeMsg = "你已成功登記【樓上3月28日尖沙咀試食嘉年華】";
    }

    
    const [content, setContent] = useState({
      Status: "",
      Title: "",
      Icon: "",
      Geocode: "",
      Mobile: "",
      Invoice_no: "",
      Created_Date: "",
      AllButton_Color: "#FFFFFF",
      AllButton_FontColor: "#FFFFFF",
      AllTitle_Color: "#FFFFFF",
      AllTitle_FontColor: "#FFFFFF",
      AllBackground_Color: "#FFFFFF",
      Event_Version : ""
    });

    if(props.isdebugmode) console.log(baseUrl);
    
    if(props.invoiceno === ""){
      navigate('../../../' + PUBLIC_URL + '/fail-wrong-url');
    } 

    useEffect(() => {
      fetch(paymentUrl, {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          "invoice_number": props.invoiceno,
          "hash" : props.hash
        })
      })
      .then(response => response.json())
      .then(response => { 
        let result = JSON.parse(JSON.stringify(response));
        if(props.isdebugmode) console.log(result);
        if (result.IsSuccess == null){
          setContent(previousState => {
            return { 
              ...previousState,
              Status : result.Status,
              Title : result.Title,
              Geocode : result.Geocode,
              Mobile : result.Mobile,
              Invoice_no : result.Invoice_no,
              Created_Date : result.Created_Date
            }
          });
        } else {
          navigate('../../../' + PUBLIC_URL + '/fail-wrong-url');
        }
      })
      .catch(err => { 
        navigate('../../../' + PUBLIC_URL + '/' + eventName + '/fail-error');
       });
    }, []);
    
    useEffect(() => {
      fetch(iconUrl, {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          "Event_Name": eventName,
          "Status": "Success"
        })
      })
      .then(response => response.json())
      .then(response => { 
        let result = JSON.parse(JSON.stringify(response));
        if(props.isdebugmode) console.log(result.url);        

        if(props.isdebugmode) console.log(window.QueueIt);
        window.isSubmitSuccesful = "yes";
        window.QueueIt && window.QueueIt.validateUser();

        setContent(previousState => {
          return { 
            ...previousState,
            Icon : result.url
          }
        });
      })
      .catch(err => { 
        //navigate('../../../' + PUBLIC_URL + '/' + eventName + '/fail-error');
      });
    }, [content.Status]);

    useEffect(() => {
      fetch(eventUrl, {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          "event_Name": eventName
        })
      })
      .then(response => response.json())
      .then(response => { 
        let result = JSON.parse(JSON.stringify(response));
        if(props.isdebugmode) console.log(result);
        if (result.IsSuccess == null){
          setContent(previousState => {
            return { 
              ...previousState,
              AllButton_Color : result.AllButton_Color,
              AllButton_FontColor : result.AllButton_FontColor,
              AllTitle_Color : result.AllTitle_Color,
              AllTitle_FontColor : result.AllTitle_FontColor,
              AllBackground_Color : result.AllBackground_Color,
              Event_Version : result.Event_Version
            }
          });

          // Redirect to enroll page if it is not non-payment event
          if (result.Event_Version != 3){
            navigate('../../../' + PUBLIC_URL + '/' + eventName + '/enroll');
          }

        } else {
          navigate('../../../' + PUBLIC_URL + '/fail-wrong-url');
        }
      })
      .catch(err => { 
        navigate('../../../' + PUBLIC_URL + '/' + eventName + '/fail-error');
        console.log(err); 
       });

    }, []);

    let successMsg = "請耐心等候樓上®透過短訊向您的手提電話號碼 " + content.Geocode + "-" + content.Mobile + " 發送的印花連結。";
    let receiveTimeMsg =  <DateConverter data={content.Created_Date} startmessage="如您於" endmessage="後尚未收到短訊，請致電顧客服務熱線查詢。"></DateConverter>

  return (
    <>
    <Form style={{backgroundColor: content.AllBackground_Color}}>
        <TitleDiv class="title" title="你的手提電話號碼已獲確認" bgColor={content.AllTitle_Color} fontColor={content.AllTitle_FontColor}></TitleDiv>
        <div className="d-grid">
            <FailIconDiv class="icon" src={content.Icon} />
            <SuccessMsgDiv class="msg-middle" msg={noticeMsg}></SuccessMsgDiv>
            <SuccessMsgDiv class="msg-middle" msg={successMsg}></SuccessMsgDiv>
            <SuccessMsgDiv class="info" msg={receiveTimeMsg}></SuccessMsgDiv>
            <ReceivedSmsDiv class="info"></ReceivedSmsDiv>
            <EnquiryDiv class="info" msg="若您無法完成登記或未收到印花短訊，請致電顧客服務熱線查詢(上午9:00 至 晚上9:00)："></EnquiryDiv>
        </div>
      </Form>
    </>
  );
}

export default NPSuccess;
